/**
 * Format a large number into a human-readable string.
 * @param num - The number to format
 * @param verbose - If true, returns multiple representations joined by newlines
 *                  (e.g., "1.3 billion\n...or 1,276.9 million"). Default: false.
 */
export const formatLargeNumber = (num: number, verbose: boolean = false): string => {
  if (!num) return "0";

  if (num < 1000000) {
    return num.toLocaleString();
  }

  const units = ['', 'thousand', 'million', 'billion', 'trillion', 'quadrillion', 'quintillion'];
  const divisors = [1, 1000, 1000000, 1000000000, 1000000000000, 1000000000000000, 1000000000000000000];

  let naturalUnitIndex = 2;
  for (let i = divisors.length - 1; i >= 2; i--) {
    if (num >= divisors[i]) {
      naturalUnitIndex = i;
      break;
    }
  }

  const value = Math.round((num / divisors[naturalUnitIndex]) * 10) / 10;
  const primary = value >= 1000000
    ? `${formatLargeNumber(value)} ${units[naturalUnitIndex]}`
    : `${value.toLocaleString()} ${units[naturalUnitIndex]}`;

  if (!verbose) {
    return primary;
  }

  const representations: string[] = [primary];
  for (let unitIndex = naturalUnitIndex - 1; unitIndex >= 2; unitIndex--) {
    const altValue = Math.round((num / divisors[unitIndex]) * 10) / 10;
    representations.push(`...or ${altValue.toLocaleString()} ${units[unitIndex]}`);
  }

  return representations.join('\n');
};
